import { IMappedTaxRateSchedule } from './../../../models/tax';
import { EntityLegalType } from './../../../models/entity';
import { Country } from 'src/app/models/country';
import { Action } from '@ngrx/store';

export const GET_COUNTRY_LIST = "GET_COUNTRY_LIST";
export const GET_COUNTRY_LIST_SUCCESS = "GET_COUNTRY_LIST_SUCCESS";
export const GET_TAX_RATE_SCHEDULE_LIST = "GET_TAX_RATE_SCHEDULE_LIST";
export const GET_TAX_RATE_SCHEDULE_LIST_SUCCESS = "GET_TAX_RATE_SCHEDULE_LIST_SUCCESS";

export class LoadCountryList implements Action {
    readonly type = GET_COUNTRY_LIST;
}
export class LoadCountryListSuccess implements Action {
    readonly type = GET_COUNTRY_LIST_SUCCESS;
    constructor(public payload: Country[]) { }
}
export class LoadTaxRateScheduleList implements Action {
    readonly type = GET_TAX_RATE_SCHEDULE_LIST;
    constructor(public payload: EntityLegalType) { }
}
export class LoadTaxRateScheduleListSuccess implements Action {
    readonly type = GET_TAX_RATE_SCHEDULE_LIST_SUCCESS;
    constructor(public payload: IMappedTaxRateSchedule) { }
}

export type UtilitiesActions = LoadCountryList | LoadCountryListSuccess | LoadTaxRateScheduleList | LoadTaxRateScheduleListSuccess;
